import { Maximize2, Minimize2, Monitor, MonitorOff, Volume2 } from 'lucide-react';
import { useFullscreen } from '../hooks/useFullscreen';
import { useWakeLock } from '../hooks/useWakeLock';

export function KioskControls() {
  const { isFullscreen, toggleFullscreen } = useFullscreen();
  const { isSupported, isActive } = useWakeLock();

  const testSound = () => {
    console.log('🧪 Testing ding sound from button');
    const audio = new Audio('/audio/ding.mp3');
    audio.volume = 0.5;
    audio.play().then(() => {
      console.log('✅ Kiosk test ding played');
    }).catch((err) => {
      console.error('❌ Kiosk test ding failed:', err.message);
    });
  };

  return (
    <div className="fixed bottom-4 right-4 z-50 flex flex-col gap-2">
      <button
        onClick={testSound}
        className="bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white p-3 rounded-full shadow-lg transition-all"
        title="Test Sound"
      >
        <Volume2 size={20} />
      </button>

      <button
        onClick={toggleFullscreen}
        className="bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white p-3 rounded-full shadow-lg transition-all"
        title={isFullscreen ? 'Exit Fullscreen' : 'Enter Fullscreen'}
      >
        {isFullscreen ? <Minimize2 size={20} /> : <Maximize2 size={20} />}
      </button>

      {isSupported && (
        <div
          className="bg-white/10 backdrop-blur-sm text-white p-3 rounded-full shadow-lg"
          title={isActive ? 'Screen Lock Active' : 'Screen Lock Inactive'}
        >
          {isActive ? <Monitor size={20} /> : <MonitorOff size={20} />}
        </div>
      )}
    </div>
  );
}
